/*
 *
 * MicrosoftVerify constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/MicrosoftVerify';

export const VERIFY_MICROSOFT = defineApiActionTypes(`${prefix}/VERIFY_MICROSOFT_START`);
